/* eslint-disable no-mixed-spaces-and-tabs */
import { ConsumptionTimeFrame, Report } from '@vae/server/dist/client'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
	observedReport: Report
	previousReport: Report | undefined | null
	averages:
		| {
				id: number
				personCount: number
				from: string
				to: string
				totalConsumption: number
				totalCO2: number
				heatingCO2: number
				timeframe: ConsumptionTimeFrame
				totalHeatingConsumption: number
				// eslint-disable-next-line no-mixed-spaces-and-tabs
		  }
		| null
		| undefined
}

const Appliances = (props: Props) => {
	const { observedReport, previousReport } = props
	const { t } = useTranslation('pages_monthlyReport')

	const applianceDifference = useMemo(() => {
		if (!previousReport) return 0
		return observedReport.applianceConsumption - previousReport.applianceConsumption
	}, [observedReport, previousReport])

	const differenceText = useMemo(() => {
		if (applianceDifference > 0) {
			return t('suurempi', { difference: applianceDifference })
		} else if (applianceDifference < 0) {
			return t('pienempi', { difference: Math.abs(applianceDifference) })
		} else {
			return t('seurataanTarkemmin')
		}
	}, [applianceDifference, t])

	return (
		<div className='card text-text-dark dark:text-white'>
			<div className='contents'>
				<div className='title'>{t('yhteenveto')}</div>
				<div className='saving-status text-text-grey-200 dark:text-text-grey-100'>
					<p>{differenceText}</p>
				</div>
				<div className='title mt-4'>{t('ehdotus')}</div>
				<div className='suggestion'>
					<div className='suggestion-text text-text-grey-200 dark:text-text-grey-100'>
						{applianceDifference > 0
							? t('taydemmatKoneet')
							: applianceDifference < 0
								? t('loistavaa')
								: t('seuraavaAnalyysi')}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Appliances
